import currencies, { networks } from './currencies';
import * as permissions from './permission-list';

const env = process.env.REACT_APP_ENV || 'development';
const config = {
  apiUrl: process.env.REACT_APP_API_URL,
  blockchainPollingInterval: 30000,
  bugsnagApiKey: process.env.REACT_APP_BUGSNAG_API_KEY,
  reseller: process.env.REACT_APP_RESELLER,
  checkoutUrl: process.env.REACT_APP_CHECKOUT_URL,
  companyName: process.env.REACT_APP_COMPANY_NAME,
  favIconUrl: process.env.REACT_APP_FAVICON_URL,
  logoUrl: process.env.REACT_APP_LOGO_URL,
  assetsUrl: process.env.REACT_APP_ASSETS_URL,
  gaTrackingId: process.env.REACT_APP_GA_TRACKING_ID,
  supportEmail: process.env.REACT_APP_SUPPORT_EMAIL,
  docsUrl: process.env.REACT_APP_DOCS_URL,
  supportUrl: process.env.REACT_APP_SUPPORT_URL,
  termsOfUseUrl: process.env.REACT_APP_TERMS_OF_USE_URL,
  privacyPolicyUrl: process.env.REACT_APP_PRIVACY_POLICY_URL,
  eSignConsentUrl: process.env.REACT_APP_ESIGN_CONSENT_URL,
  helpscoutBeaconId: process.env.REACT_APP_HELPSCOUT_BEACON_ID,
  helpscoutBeaconEnabled: process.env.REACT_APP_HELPSCOUT_BEACON_ENABLED === 'true',
  hereMaps: {
    appId: process.env.REACT_APP_HERE_APP_ID,
    appCode: process.env.REACT_APP_HERE_APP_CODE
  },
  appVersion: require('../package.json').version,
  env,
  supportedCountries: ['USA', 'CAN'],
  fiatCurrencies: [
    { symbol: '$', name: 'USD', country: 'US', supportsBanking: true },
    { symbol: '$', name: 'CAD', country: 'CA', supportsBanking: true },
    { symbol: '$', name: 'AUD', country: 'AU', supportsBanking: true },
    { symbol: '$', name: 'BMD', country: 'BM', supportsBanking: true },
    { symbol: '€', name: 'EUR', country: 'EU', supportsBanking: true },
    { symbol: '£', name: 'GBP', country: 'GB', supportsBanking: true },
    { symbol: '¥', name: 'CNY', country: 'CN', supportsBanking: true, disabledForInvoices: true },
    { symbol: 'R$', name: 'BRL', country: 'BR', supportsBanking: true, disabledForInvoices: true },
    { symbol: '$', name: 'HKD', country: 'HK', supportsBanking: true, disabledForInvoices: true },
    { symbol: '$', name: 'MXN', country: 'MX', supportsBanking: true, disabledForInvoices: true },
    { symbol: '₹', name: 'INR', country: 'IN', supportsBanking: false, disabledForInvoices: true }
  ],
  currencies,
  networks,
  permissions
};

export default config;
